import Page from 'components/modules/public/pages/CompanyPolicy';
export default Page;